import { Children, forwardRef, ReactNode } from 'react';
import { ArrayKit } from '@team/array';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../services/root-component';
import { Divider, DividerOrientation } from '../divider';
import { Props } from './types';
import css from './style.module.css';

const orientationPresets: Record<DividerOrientation, string> = {
  [DividerOrientation.HORIZONTAL]: css.horizontal,
  [DividerOrientation.VERTICAL]: css.vertical,
};

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  {
    orientation = DividerOrientation.HORIZONTAL,
    shouldStretched = false,
    children,
    ...props
  },
  forwardedRef
) {
  const dividerOrientation =
    orientation === DividerOrientation.HORIZONTAL
      ? DividerOrientation.VERTICAL
      : DividerOrientation.HORIZONTAL;

  const items = Children.toArray(children).reduce<ReactNode[]>(
    (acc, child, index) => {
      if (ArrayKit.isHeadElement(index)) {
        return [child];
      }

      return [
        ...acc,
        <Divider
          key={`divider-${index}`}
          className={css.divider}
          orientation={dividerOrientation}
        />,
        child,
      ];
    },
    []
  );

  return (
    <RootComponent
      {...props}
      Component="div"
      baseClassName={clsx(css.root, orientationPresets[orientation], {
        [css.stretched]: shouldStretched,
      })}
      role="group"
      ref={forwardedRef}
    >
      {items}
    </RootComponent>
  );
});
